import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BrandInfo, StoryblokBrandInfo } from '../../models';
import { NUMBER_768 } from '~shared/constants';
import { LOGO_FIT_SIZE } from '~app/modules/storyblok/constants';
import { Category } from '~app/modules/generic/models';

@Component({
  selector: 'app-brand-plp-brand-info',
  templateUrl: './brand-info.component.html',
  styleUrls: ['./brand-info.component.scss'],
})
export class BrandInfoComponent implements OnInit {
  @Input() brandInfo: BrandInfo;
  @Input() categories: Category[];
  @Input() isMobileOrTablet: boolean;
  @Input() storyBrandContent: StoryblokBrandInfo;
  logoFitSize: string;

  @HostListener('window:resize')
  onResize() {
    this.logoFitSize = window.innerWidth > NUMBER_768 ? LOGO_FIT_SIZE.md : LOGO_FIT_SIZE.sm;
  }

  ngOnInit() {
    this.onResize();
  }
}
